import { render } from "./HomeSpellingRuleCategoryTree.vue?vue&type=template&id=5dde4ceb&scoped=true&ts=true"
import script from "./HomeSpellingRuleCategoryTree.vue?vue&type=script&lang=ts"
export * from "./HomeSpellingRuleCategoryTree.vue?vue&type=script&lang=ts"

import "./HomeSpellingRuleCategoryTree.vue?vue&type=style&index=0&id=5dde4ceb&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dde4ceb"]])

export default __exports__